"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var editor_web_1 = require("@21st-night/editor-web");
function serializeCardFormData(data) {
    var hasSummary = data.summary && !editor_web_1.isDocumentEmpty(data.summary);
    var hasExplanation = data.explanation && !editor_web_1.isDocumentEmpty(data.explanation);
    var doc = {
        answer: editor_web_1.serializeDocument(data.answer),
        question: editor_web_1.serializeDocument(data.question),
    };
    if (hasExplanation) {
        doc.explanation = editor_web_1.serializeDocument(data.explanation);
    }
    if (hasSummary) {
        doc.summary = editor_web_1.serializeDocument(data.summary);
    }
    return doc;
}
exports.default = serializeCardFormData;
//# sourceMappingURL=serializeCardFormData.js.map